import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SelectOption, SelectProps } from '@ui';
// constants
import { EmailTypes } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = SelectProps;

const EmailTypeSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(EmailTypes).map((key) => ({
        id: key,
        label: t(`applicant_information.email_types.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default EmailTypeSelect;
